import { Module } from 'vuex'

import { DashboardUseCase } from '@/application/dashboard/dashboardUseCase'
import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { DashboardRepository } from '@/domain/repositories/dashboard/DashboardRepository'

interface HeatMapState {
  userJudgeRecordList: JudgeRecord[]
  heatMapSeries: any[]
  heatMapXLabel: string[]
  isLoading: boolean
  error: Error | null
}

export const heatMapModule = (repository: DashboardRepository): Module<HeatMapState, any> => {
  const usecase = new DashboardUseCase(repository)

  return {
    namespaced: true,
    state: {
      userJudgeRecordList: [],
      heatMapSeries: [],
      heatMapXLabel: [],
      isLoading: false,
      error: null
    },
    mutations: {
      setUserJudgeRecord(state, { records }: { records: JudgeRecord[] }) {
        state.userJudgeRecordList = records
      },
      setHeatMapSeries(state, { series }: { series: any[] }) {
        state.heatMapSeries = series
      },
      setHeatMapXLabel(state, { labels }: { labels: string[] }) {
        state.heatMapXLabel = labels
      },
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async getUserJudgeRecord({ state, commit }, { userId }: { userId: string }) {
        commit('setIsLoading', true)
        commit('setError', null)

        try {
          const res = await usecase.getUserJudgeRecordList(userId)
          commit('setUserJudgeRecord', {
            records: res
          })
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setIsLoading', false)
        }
      }
    },
    getters: {
      userJudgeRecordList: state => state.userJudgeRecordList,
      heatMapXLabel: state => state.heatMapXLabel,
      heatMapSeries: state => state.heatMapSeries,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
